import { h } from 'preact';
import styles from './progress.module.css';
import { Props } from '@divriots/create-figma-plugin-ui';

export type ProgressProps = {
  height?: string;
  max: number;
  value: number;
};

export function Progress({
  height = '.5rem',
  max,
  value,
  ...rest
}: Props<HTMLDivElement, ProgressProps>): h.JSX.Element {
  const container_style = {
    ...rest.style,
    height,
  };

  const bar_style = {
    width: Math.floor((value / max) * 100) + '%',
  };

  return (
    <div
      {...rest}
      role="progressbar"
      className={styles.progress_container}
      style={container_style}
    >
      <div className={styles.progress_bar} style={bar_style}></div>
    </div>
  );
}
